<template>
  <div class="tagList-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-select v-model="params.filterValue" size="small" @change="getTagList('status')" v-if="false">
        <el-option v-for="item in wonder" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select v-model="params.isSource" size="small" @change="getTagList('isSource')">
        <el-option label="是否片源标签" :value="-1"></el-option>
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="0"></el-option>
      </el-select>
      <el-select v-model="params.isCommonUsed" size="small" @change="getTagList('isCommonUsed')">
        <el-option label="是否是常用标签" :value="-1"></el-option>
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="0"></el-option>
      </el-select>
      <el-select v-model="params.isActive" size="small" @change="getTagList('isActive')">
        <el-option label="是否发布" :value="-1"></el-option>
        <el-option label="是" :value="1"></el-option>
        <el-option label="否" :value="0"></el-option>
      </el-select>
      <el-input
        placeholder="请输入标签名"
        size="small"
        v-model="params.content"
        class="param-input"
        clearable
        @keyup.enter.native="getTagList"
      ></el-input>
      <div class="pr ftp5 flex ">
        <el-button type="primary" size="small" @click="getTagList">搜索</el-button>
        <div class="ml-5"><el-button type="primary" size="small" @click="tagsAction('add')">+新增标签</el-button></div>
      </div>
    </div>
    <!--数据表格-->
    <el-table
      height="calc(100vh - 220px)"
      :data="tableData"
      style="width: 100%"
      border
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @sort-change="handleSortChange"
    >
      <el-table-column prop="id" label="ID" align="center" width="220" fixed></el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
        width="360"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag type="success" size="mini" effect="plain" class="tags">{{'#' + scope.row.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          v-if="false"
        prop="tgaDesc"
        label="描述"
        align="center"
        width="160"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.tagDesc }}
        </template>
      </el-table-column>
      <el-table-column prop="usedSortCode" label="常用排序" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{scope.row.usedSortCode || 0}}</span>
        </template>
      </el-table-column>
      <el-table-column
          v-if="false"
          prop="wonderSortCode"
          label="精彩排序"
          align="center"
          width="120"
          :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{(scope.row.wonderSortCode || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isSource" label="是否片源" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isSource" @change="updateFiled(scope.row,'isSource')"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="isCommonUsed" label="是否常用" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isCommonUsed" @change="updateFiled(scope.row,'isCommonUsed')"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否启用" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isActive" @change="updateFiled(scope.row,'isActive')"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="isWonder" label="推送至发现" align="center" width="120" v-if="false">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isWonder" @change="changeWonder(scope.row,'isWonder')" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoCount"
        label="视频数"
        align="center"
        width="140"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{(scope.row.videoCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tPlayCount"
        label="总播放量(真)"
        align="center"
        width="140"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{(scope.row.tPlayCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fakePlayCount" label="播放量(假)" align="center" width="100">
        <template slot-scope="scope">
          <span>{{(scope.row.fakePlayCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="vPlayCount"
        label="有效播放量"
        align="center"
        width="140"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{(scope.row.vPlayCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="collCount" label="收藏数" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{(scope.row.collCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="playRating"
        label="有效播放率"
        align="center"
        width="140"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{(scope.row.playRating || 0) | numFormat}}%</span>
        </template>
      </el-table-column>

      <el-table-column prop="createdAt" label="创建时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.createdAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
            type="success"
            class="el-icon-edit"
            size="mini"
            @click="tagsAction('edit',scope.row)"
          >编辑</el-button>
          <div v-if="false">
            <el-button
                v-if="scope.row.isRecmd"
                type="warning"
                size="mini"
                @click="remove(scope.row)"
            >取消推荐</el-button>
            <el-button v-else type="success" size="mini" @click="addRecommendTag('add',scope.row)">推荐</el-button>
          </div>
          <el-button type="danger" size="mini" @click="delTable(scope.row,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 5"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <tag-action ref="tagAction" @handlerTagList="handlerTagList"></tag-action>
    <add-recommendTag ref="addRecommendTag" @handlerTagList="handlerTagList"></add-recommendTag>
  </div>
</template>
<script>
import TagAction from "./components/addTag";
import addRecommendTag from "./components/addRecommendTag";
import {sortEscape} from "@/utils/global";
import API from "@/api";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      imgUrl: baseConfig.imgUrl,
      wonder: [
        {
          label: "全部",
          value: 0
        },
        {
          label: "精彩标签",
          value: 1
        },
        {
          label: "非精彩",
          value: 2
        },
      ],
      params: {
        pageNumber: 1,
        pageSize: 20,
        content: "",
        key: "",
        value: "",
        filterValue: 0,
        isCommonUsed:-1,
        isSource:-1,
        isActive:-1,
      }
    };
  },
  components: {
    TagAction,
    addRecommendTag
  },
  created() {
    this.getTagList();
  },
  methods: {
    // 请求tag列表数据
    getTagList(type) {
      if (type) {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getTagList(this.params)
        .then(res => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getTagList();
    },
    // 分页条数发生变化时触发
    changeSize(number) {
      this.params.pageSize = number;
      this.getTagList();
    },
    // 当前页发生变化时触发
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getTagList();
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerTagList() {
      this.params.pageNumber = 1;
      this.params.pageSize = 15;
      this.getTagList();
    },
    // 删除tags
    remove(row) {
      this.$confirm("您确定要取消推荐吗？", "取消提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.deleteRecmdList({ id: row.rid }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getTagList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑tags
    tagsAction(type, data) {
      this.$refs.tagAction.open(type, data);
    },
    // 新增、编辑tags
    addRecommendTag(type, data) {
      this.$refs.addRecommendTag.open(type, data);
    },
    // 删除标签
    delTable(row,index) {
      if (row.isActive === true) {
      this.$message.error('当前标签为开启状态，不能删除！')
        return false
      }
      this.$confirm('您确定要删除当前标签吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.deleteTags({ id: [row.id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.tableData.splice(index,1)
              if(this.tableData.length == 0)this.getTagList();
            } else {
              this.$message.error('删除失败！');
            }
          })
        })
    },
    // 更新
    updateFiled(row) {
      this.$confirm("您确定要执行此操作吗", "推送提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.editTags(row)
            .then(res => {
              if (res.code === 200) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.getTagList();
              } else {
                this.$message.error("操作失败");
              }
            })
            .catch(() => {
              this.$message.error("操作失败");
            });
      });
    },
    // 推送至发现
    changeWonder(row) {
      row.isWonder = !row.isWonder;
      let text = row.isWonder
        ? "您确定要取消当前标签的发现推送吗？"
        : "您确定要推送当前标签至发现吗？";
      this.$confirm(text, "推送提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        row.isWonder ? this.cancelWonder(row) : this.pushWonder(row);
      });
    },
    // 推送至发现
    pushWonder(row) {
      API.pushWonder({ tagID: row.id })
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "推送成功",
              type: "success"
            });
            this.getTagList();
          } else {
            this.$message.error("推送失败！");
          }
        })
        .catch(() => {
          this.$message.error("推送失败！");
        });
    },
    // 删除推送精彩
    cancelWonder(row) {
      API.deleteWonder({ idArray: [row.wID] })
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "取消推送成功",
              type: "success"
            });
            this.getTagList();
          } else {
            this.$message.error("取消推送失败");
          }
        })
        .catch(() => {
          this.$message.error("取消推送失败");
        });
    },
    // 更新
  },
};
</script>


